import { useLanguage } from "../contexts/LanguageContext";

const MentionsLegalesPage = () => {
  const { t } = useLanguage();

  return (
    <div data-testid="mentions-legales-page" className="min-h-screen bg-slate-50 pt-24 pb-16">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <h1 className="text-4xl font-bold text-[#0F172A] mb-8">Mentions Légales</h1>
        
        <div className="bg-white rounded-2xl shadow-sm p-8 space-y-8">
          {/* Identification */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">1. Identification de l'entreprise</h2>
            <div className="space-y-2 text-slate-600">
              <p><strong>Dénomination sociale :</strong> Nettis Facility SRL</p>
              <p><strong>Forme juridique :</strong> Société à Responsabilité Limitée (SRL)</p>
              <p><strong>Siège social :</strong> Avenue Louise 65 boîte 11, 1050 Bruxelles, Belgique</p>
              <p><strong>Numéro d'entreprise (BCE) :</strong> 0788.309.595</p>
              <p><strong>Numéro de TVA :</strong> BE0788.309.595</p>
              <p><strong>Téléphone :</strong> +32 2 880 66 50</p>
              <p><strong>Email :</strong> info@nettis.be</p>
            </div>
          </section>

          {/* Responsable */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">2. Responsable de publication</h2>
            <p className="text-slate-600">
              Le responsable de la publication du site www.nettis.be est le gérant de la société Nettis Facility SRL.
            </p>
          </section>

          {/* Hébergement */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">3. Hébergement</h2>
            <p className="text-slate-600">
              Ce site est hébergé par Emergent.<br />
              Pour toute question relative à l'hébergement, veuillez nous contacter à l'adresse : info@nettis.be
            </p>
          </section>

          {/* Propriété intellectuelle */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">4. Propriété intellectuelle</h2>
            <p className="text-slate-600">
              L'ensemble du contenu de ce site (textes, images, logos, graphismes, icônes, etc.) est la propriété 
              exclusive de Nettis Facility SRL ou de ses partenaires. Toute reproduction, distribution, modification, 
              adaptation, retransmission ou publication de ces éléments est strictement interdite sans l'accord 
              écrit préalable de Nettis Facility SRL.
            </p>
          </section>

          {/* Limitation de responsabilité */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">5. Limitation de responsabilité</h2>
            <p className="text-slate-600">
              Nettis Facility SRL s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées 
              sur ce site. Toutefois, Nettis Facility SRL ne peut garantir l'exactitude, la précision ou 
              l'exhaustivité des informations mises à disposition sur ce site. En conséquence, Nettis Facility SRL 
              décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des 
              informations disponibles sur ce site.
            </p>
          </section>

          {/* Liens externes */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">6. Liens externes</h2>
            <p className="text-slate-600">
              Ce site peut contenir des liens vers d'autres sites internet. Nettis Facility SRL n'exerce aucun 
              contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
            </p>
          </section>

          {/* Droit applicable */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">7. Droit applicable</h2>
            <p className="text-slate-600">
              Le présent site et ses mentions légales sont régis par le droit belge. En cas de litige, 
              les tribunaux de Bruxelles seront seuls compétents.
            </p>
          </section>

          {/* Date de mise à jour */}
          <section className="pt-4 border-t border-slate-200">
            <p className="text-sm text-slate-500">
              Dernière mise à jour : Juillet 2025
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;
